{
  "agb-to-accept-dialog": {
    "buttons": {
      "agree": "Đồng ý",
      "deny-and-logout": "Từ chối và đăng xuất"
    },
    "text": {
      "agb": "Điều khoản chung (ĐKC)"
    }
  }
}
